const SW_PATH = '/firebase-messaging-sw.js'

/** 프로덕션에서 PWA 설치 조건( manifest + SW ) 충족용 등록 */
export function registerPwaServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  if (process.env.NODE_ENV !== 'production') return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_PATH).catch((err) => {
      console.warn('[PWA] 서비스 워커 등록 실패:', err)
    })
  })
}
